import React, { FunctionComponent, useCallback } from 'react';
import { useForm } from 'react-hook-form';

import { HomeFullPageProps } from 'scenes/home/types';
import { SubmitButton } from 'components';
import NameQuestion from 'scenes/common/components/Questions/NameQuestion';
import { DateOfBirthQuestion } from 'scenes/common/components/Questions';
import { getAdditionalPolicyHolder } from 'scenes/home/selectors';

const FIRST_NAME = 'firstName';
const LAST_NAME = 'lastName';
const DOB = 'dob';

const MIN_AGE = 18;
const MAX_AGE = 100;

export const FIRST_NAME_QUESTION = 'Additional policy holder first name';
export const LAST_NAME_QUESTION = 'Additional policy holder last name';
export const DOB_QUESTION = 'Additional policy holder date of birth';

const AdditionalPolicyHolderStep: FunctionComponent<HomeFullPageProps> = ({
  funnelState,
  onUpdateAdditionalPolicyHolder,
  onAddAdditionalPolicyHolder,
}) => {
  const {
    formState: hooksForm,
    handleSubmit,
    control,
    errors,
    getValues,
  } = useForm({
    mode: 'onChange',
  });

  const policyHolder = getAdditionalPolicyHolder(funnelState);

  const onSubmit = useCallback(() => {
    const { firstName, lastName, dob } = getValues();
    const policyHolderIndex =
      funnelState.policyDetails.additionalPolicyHolder?.index;
    if (policyHolderIndex !== undefined) {
      onUpdateAdditionalPolicyHolder(policyHolderIndex, {
        firstName,
        lastName,
        dob,
      });
    } else {
      onAddAdditionalPolicyHolder({
        firstName,
        lastName,
        dob,
      });
    }
  }, [
    funnelState.policyDetails.additionalPolicyHolder,
    getValues,
    onAddAdditionalPolicyHolder,
    onUpdateAdditionalPolicyHolder,
  ]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="on">
      <NameQuestion
        errors={errors}
        control={control}
        stateKey={FIRST_NAME}
        defaultValue={policyHolder.firstName}
        autoCompleteName="given-name"
        question={FIRST_NAME_QUESTION}
      />
      <NameQuestion
        stateKey={LAST_NAME}
        errors={errors}
        control={control}
        question={LAST_NAME_QUESTION}
        defaultValue={policyHolder.lastName}
        autoCompleteName="family-name"
      />
      <DateOfBirthQuestion
        question={DOB_QUESTION}
        minAge={MIN_AGE}
        maxAge={MAX_AGE}
        entityType="policy holder"
        defaultValue={policyHolder.dob}
        stateKey={DOB}
        errors={errors}
        control={control}
      />
      <SubmitButton enabled={hooksForm.isValid}>Next</SubmitButton>
    </form>
  );
};

export default AdditionalPolicyHolderStep;
